import { render, staticRenderFns } from "./scorecard-order-clubspecific.vue?vue&type=template&id=532fdb1f&scoped=true"
import script from "./scorecard-order-clubspecific.vue?vue&type=script&lang=js"
export * from "./scorecard-order-clubspecific.vue?vue&type=script&lang=js"
import style0 from "./scorecard-order-clubspecific.vue?vue&type=style&index=0&id=532fdb1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532fdb1f",
  null
  
)

export default component.exports